import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';
import style from './item-display.module.less';

export const ItemDisplayImage = ({ productThumbnailUrl = '', name = '' }) => {
  const [hasImageErrored, setHasImageErrored] = useState(false);

  const onImageRetrieveError = useCallback(() => {
    setHasImageErrored(true);
  }, []);

  if (!productThumbnailUrl || hasImageErrored) {
    return (
      <div className={classnames(style['item-image'], style['empty-image'])} {...testId('no-image-display')}>
        <FontAwesomeIcon icon={faImage} />
      </div>
    );
  }
  return (
    <div className={style['item-image']} {...testId('image-display')}>
      <img alt={name} onError={onImageRetrieveError} src={productThumbnailUrl} />
    </div>
  );
};

ItemDisplayImage.propTypes = {
  productThumbnailUrl: PropTypes.string,
  name: PropTypes.string,
};
